import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { SliderComponent } from './components/slider/slider.component';
import { InputRupeeComponent } from './components/input-rupee/input-rupee.component';
import { SpeedometerComponent } from './components/speedometer/speedometer.component';
import { DoughnutChartComponent } from './components/doughnut-chart/doughnut-chart.component';
import { CommaSeparatedNumberPipe } from './pipes/CommaSeparatedNumberPipe';
import { DoughnutChartjsComponent } from './components/doughnut-chartjs/doughnut-chartjs.component';
import { Ng5SliderModule } from 'ng5-slider';

@NgModule({
  imports: [CommonModule, FormsModule, Ng5SliderModule],
  declarations: [
    SliderComponent,
    InputRupeeComponent,
    SpeedometerComponent,
    DoughnutChartComponent,
    CommaSeparatedNumberPipe,
    DoughnutChartjsComponent,
  ],
  exports: [
    SliderComponent,
    InputRupeeComponent,
    SpeedometerComponent,
    DoughnutChartComponent,
    CommaSeparatedNumberPipe,
    DoughnutChartjsComponent,
  ],
  providers: [CommaSeparatedNumberPipe],
})
export class SharedModule {}



// WEBPACK FOOTER //
// ./src/app/modules/shared/shared.module.ts